import { z } from 'zod';
export const CustomerOverviewMetricsQuerySchema = z.object({
    from_date: z.string().optional(),
    to_date: z.string().optional(),
});
export const CustomerOverviewMetricsResponseSchema = z.object({
    active_contracts: z.number(),
    customer_since: z.string().datetime(),
});
//# sourceMappingURL=overview-metrics.schema.js.map